import {
  LaptopMinimal,
  PartyPopper,
  Box,
  Search,
  Bot,
  FileText,
  Users,
  Hash,
  FileSignature,
  Megaphone,
  Rocket,
  FileSpreadsheet,
} from "lucide-react";

// Map backend icon strings to lucide-react components
export const iconMap = {
  "laptop-code": LaptopMinimal,
  "party-popper": PartyPopper,
  "magnifying-glass-chart": Search,
  robot: Bot,
  "file-invoice-dollar": FileText,
  users: Users,
  hashtag: Hash,
  "file-signature": FileSignature,
  bullhorn: Megaphone,
  rocket: Rocket,
  "file-spreadsheet": FileSpreadsheet,
};

export function getServiceIcon(name) {
  return iconMap[name] || Box || LaptopMinimal;
}

// Accent color -> tailwind classes for icon containers
export const accentClasses = {
  blue: { text: "text-blue-400", bg: "bg-blue-500/10", border: "border-blue-500/20", glow: "shadow-[0_0_20px_rgba(59,130,246,0.25)]" },
  purple: { text: "text-purple-400", bg: "bg-purple-500/10", border: "border-purple-500/20", glow: "shadow-[0_0_20px_rgba(168,85,247,0.25)]" },
  green: { text: "text-green-400", bg: "bg-green-500/10", border: "border-green-500/20", glow: "shadow-[0_0_20px_rgba(34,197,94,0.25)]" },
  orange: { text: "text-orange-400", bg: "bg-orange-500/10", border: "border-orange-500/20", glow: "shadow-[0_0_20px_rgba(249,115,22,0.25)]" },
};

export function getAccent(name) {
  return accentClasses[name] || accentClasses.blue;
}
